import { render, staticRenderFns } from "./Expert2RequirementEdit.vue?vue&type=template&id=60af334e&scoped=true&"
import script from "./Expert2RequirementEdit.vue?vue&type=script&lang=js&"
export * from "./Expert2RequirementEdit.vue?vue&type=script&lang=js&"
import style0 from "./Expert2RequirementEdit.vue?vue&type=style&index=0&id=60af334e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af334e",
  null
  
)

export default component.exports